import api from './client';

export const searchPrice = (data: any) => api.post('/pricing/search/', data);
export const getMarkupRules = () => api.get('/pricing/markup-rules/');
export const createMarkupRule = (data: any) => api.post('/pricing/markup-rules/', data);
export const updateMarkupRule = (id: string, data: any) => api.patch(`/pricing/markup-rules/${id}/`, data);
